module.exports = __webpack_public_path__ + "static/futura-medium-ee64fb9d3f1ba2333e1b489283925bce.ttf";